import React from 'react';
import GenericSearchBar from './GenericSearchBar';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const StockSearchBar = ({ 
  onSymbolSelect, 
  maxSymbols = Infinity, 
  currentSymbols = [],
  disabled = false,
  hideSearch = false,
  ...props 
}) => {
  const theme = useTheme();

  const getTypeColor = (type) => {
    switch (type) {
      case 'stock':
        return theme.palette.primary.main;
      case 'crypto':
        return theme.palette.success.main;
      case 'index':
        return theme.palette.warning.main;
      default:
        return theme.palette.text.primary;
    }
  };

  const renderStockResultItem = (result) => (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="subtitle1" component="span" fontWeight="bold">
          {result.symbol}
        </Typography>
        <Typography 
          variant="caption" 
          component="span"
          sx={{ 
            color: getTypeColor(result.type),
            fontWeight: 'bold',
            textTransform: 'uppercase'
          }}
        >
          {result.type}
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary">
        {result.name}
      </Typography>
      {result.exchange && (
        <Typography variant="caption" color="text.secondary">
          {result.exchange}
        </Typography>
      )}
      {result.price && (
        <Typography variant="body2" fontWeight="medium" sx={{ mt: 0.5 }}>
          ${result.price.toFixed(2)}
        </Typography>
      )}
    </Box>
  );

  // Modified to pass full result data
  const handleResultSelect = (symbol, resultData) => {
    onSymbolSelect(symbol, resultData);
  };

  return (
    <GenericSearchBar
      onResultSelect={handleResultSelect}
      maxSelections={maxSymbols}
      currentSelections={currentSymbols}
      searchEndpoint="/api/search-tradable"
      placeholder="Search assets..."
      getResultValue={(result) => result.symbol}
      renderResultItem={renderStockResultItem}
      disabled={disabled}
      hideSearch={hideSearch}
      {...props}
    />
  );
};

export default StockSearchBar;